<script>
	import BackButton from "./BackButton.svelte";

	export let href = "";
	export let title = "";
</script>

<div id="single-result-header" class="fixed left-0 top-0 z-50 w-full">
	<div
		class=" mx-auto flex min-h-12 w-full basis-full items-center justify-start gap-2 bg-gray-800 p-1 px-2 text-white {$$props.class}"
	>
		<BackButton
			{title}
			buttonProps={{
				textColor: "text-white",
				css: "px-0"
			}}
			keepOnPageHref={href}
		></BackButton>

		<slot />
	</div>
	<slot name="footer" />
</div>
